import React from 'react';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from 'react-oidc-context';
import { ToastContainer } from 'react-toastify';
import App from 'components/App';

// NOTE: these auth screens now live in src/components/AuthGate.jsx (and
// src/routes/ApolloRoutes for the `secure` variants). Kept here for reference.
// import { Authenticating } from 'components/Authenticating';
// import { AuthenticationComplete } from 'components/AuthenticationComplete';
// import { NotAuthenticated } from 'components/NotAuthenticated';
// import { NotAuthorized } from 'components/NotAuthorized';
// import { SessionLost } from 'components/SessionLost';
// import { oidcConfiguration } from 'services/oidc-config-provider'; // now consumed by services/user-manager.js

import { userManager } from 'services/user-manager';
import { AuthGate } from 'components/AuthGate';
import { stripCallbackFromUrl, consumePostLoginRedirect } from 'utils/url';
import { ApolloProvider } from './ApolloProvider';

import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store'

import 'react-loading-skeleton/dist/skeleton.css';
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-input-2/lib/style.css";
import 'react-accessible-accordion/dist/fancy-example.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

const rootElement = document.getElementById('root');

const queryClient = new QueryClient();
const container = document.getElementById("root");
const root = createRoot(container);

// Problem: `?code=` is single-use, the path isn't a route (→ "Oops"), 
// and React Router still thinks you're there, so no redirect to base url
// Fix: rewrite the whole URL to `/` (`replaceState`, not just the query) __and__ dispatch `popstate` 
// so React Router notices and matches `/` → redirects to `/search-business-ai`.

const onSigninCallback = () => {

  // Initially when no token was found, we called login(), that redirected to /, and not on intended route.
  // Now Land on the route the user originally requested (e.g. a deep link opened in a new tab),
  //  falling back to the app root when there is nothing remembered.
  stripCallbackFromUrl(consumePostLoginRedirect());
};


const Root = () => (

  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
        <ApolloProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter basename={baseUrl}>
              <AuthGate>
                <App />
              </AuthGate>
              <ToastContainer hideProgressBar={true} />
            </BrowserRouter>
          </QueryClientProvider>
        </ApolloProvider>
      </AuthProvider>
    </PersistGate>
  </Provider>
);

root.render(<Root />, rootElement);
